<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'ml' }" :title="this.$t('management_page.recording_storage_path_validation')")
    .form
      b-row.mb-2
        b-col.d-flex.align-items-center(cols="12")
          b-form-input(v-model="form.text" size="sm" :disabled="isCheck")
      b-row
        b-col.d-flex.align-items-center(cols="12")
          span(v-if="isCheck") {{$t('management_page.storage_path_unreachable')}}
          span(v-else) {{$t('management_page.storage_access_success')}}

      .modal-footer
        template(v-if="isCheck")
          b-btn.btn-secondary(size="sm" @click="visible = false" pill) {{$t('cancel')}}
        template(v-else)
          b-btn.btn-secondary(size="sm" @click="visible = false" pill) {{$t('cancel')}}
          b-btn(size="sm" variant="primary" @click="visible = false" pill) {{$t('save')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      form: {},
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.form {
  padding: 10px 30px;
}
</style>
